<template>
	<main>
		<HeaderTab 
			:title="$t('client_area.suivi_utilisateur')" 
            :swiper_tabs="swiper_tabs" 
		/>

        <div id="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-12">
						<router-view></router-view>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>


<script type="text/javascript">
	export default {
		name: "UserTrackingCa",
		computed: {
			swiper_tabs() {
				return [{
						label: 'client_area.tracking_account',
						href : 'accountTrackingCa',
						active: true
					}, {
						label: 'client_area.tracking_connection',
						href : 'connectionTrackingCa',
                        active: false
					}
				]
			}
		},
		components: {
			HeaderTab: () => import('@/components/HeaderTab')
		}
	}
</script>
